
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import CaptchaField from '../../components/base/CaptchaField';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-0 pb-0">
        <div className="relative w-full min-h-[320px] md:min-h-[380px]">
          <img
            src="https://public.readdy.ai/ai/img_res/85fa26ce84b8839ff36229fa845e8736.jpg"
            alt="Premium Customer Service - Drixem Group Contact"
            title="Contact Drixem Group"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
          <div className="relative z-10 flex items-center justify-center min-h-[320px] md:min-h-[380px] py-20 px-4 sm:px-6">
            <div className="text-center w-full max-w-4xl mx-auto">
              <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-3 sm:mb-4 leading-tight">
                Let&apos;s Build Wealth Together
              </h1>
              <p className="text-sm sm:text-lg md:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed px-2">
                Your next <strong>high-yield investment</strong> starts with a conversation. Reach out and unlock exclusive opportunities.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact & Quick Links */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left column – contact details */}
            <div>
              <h2 className="text-3xl font-display font-bold text-gray-900 mb-8">Get In Touch</h2>

              <div className="space-y-6 mb-12">
                {/* Headquarters */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Headquarters</h3>
                    <p className="text-gray-600">Seremban, Negeri Sembilan, Malaysia</p>
                  </div>
                </div>

                {/* WhatsApp */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className="ri-whatsapp-line text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">WhatsApp</h3>
                    <a
                      href="https://wa.me/60122353795"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary-600 hover:text-primary-700 transition-colors cursor-pointer font-medium"
                    >
                      +6012-2353795
                    </a>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Phone</h3>
                    <a
                      href="tel:+60122353795"
                      className="text-primary-600 hover:text-primary-700 transition-colors cursor-pointer font-medium"
                    >
                      +6012-2353795
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Email</h3>
                    <a
                      href="mailto:IR@drixemgroup.com"
                      className="text-primary-600 hover:text-primary-700 transition-colors cursor-pointer font-medium"
                    >
                      IR@drixemgroup.com
                    </a>
                  </div>
                </div>

                {/* Business Hours */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className="ri-time-line text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Business Hours</h3>
                    <p className="text-gray-600">
                      Monday – Friday: 9:00 AM – 6:00 PM<br />
                      Saturday – Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>

              {/* Quick Links */}
              <div className="bg-gradient-to-br from-primary-50 to-accent-50 rounded-2xl p-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Quick Links</h3>
                <div className="space-y-3">
                  <Link
                    to="/investor-relations"
                    className="flex items-center space-x-3 text-gray-700 hover:text-primary-600 transition-colors"
                  >
                    <i className="ri-arrow-right-line"></i>
                    <span>Investment Opportunities</span>
                  </Link>
                  <Link
                    to="/divisions"
                    className="flex items-center space-x-3 text-gray-700 hover:text-primary-600 transition-colors"
                  >
                    <i className="ri-arrow-right-line"></i>
                    <span>Our Business Divisions</span>
                  </Link>
                  <Link
                    to="/digital-assets"
                    className="flex items-center space-x-3 text-gray-700 hover:text-primary-600 transition-colors"
                  >
                    <i className="ri-arrow-right-line"></i>
                    <span>Digital Platforms</span>
                  </Link>
                  <Link
                    to="/careers"
                    className="flex items-center space-x-3 text-gray-700 hover:text-primary-600 transition-colors"
                  >
                    <i className="ri-arrow-right-line"></i>
                    <span>Career Opportunities</span>
                  </Link>
                </div>
              </div>
            </div>

            {/* Right column – enquiry form */}
            <div>
              <h2 className="text-3xl font-display font-bold text-gray-900 mb-8">Online Enquiry</h2>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <FAQSection />

      {/* Investor Appointment Booking */}
      <section className="py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary-50 rounded-full mb-6">
              <i className="ri-calendar-check-line text-primary-600"></i>
              <span className="text-sm text-primary-700 font-medium">For Potential Investors</span>
            </div>
            <h2 className="text-4xl font-display font-bold text-gray-900 mb-6">
              Book an Appointment
            </h2>
            <p className="text-xl text-gray-600">
              Schedule a meeting with our investment team at our <strong>Seremban</strong> or <strong>Johor</strong> office
            </p>
          </div>
          <AppointmentForm />
        </div>
      </section>

      {/* Location Map */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-display font-bold text-gray-900 mb-6">Our Location</h2>
            <p className="text-xl text-gray-600">Visit our headquarters in Seremban, Negeri Sembilan, Malaysia</p>
          </div>

          <div className="w-full h-96 rounded-2xl overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3988.2!2d101.97836!3d2.68164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMsKwNDAnNTMuOSJOIDEwMcKwNTgnNDIuMSJF!5e0!3m2!1sen!2smy!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Drixem Group HQ - Seremban Negeri Sembilan Malaysia"
              aria-label="Drixem Group headquarters location map at Seremban Negeri Sembilan Malaysia"
            ></iframe>
          </div>
        </div>
      </section>

      {/* WhatsApp CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="bg-primary-600 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="text-3xl font-display font-bold text-white mb-4">Prefer to Chat on WhatsApp?</h2>
            <p className="text-white/90 mb-8 max-w-2xl mx-auto">
              Get a quick response from our team. We&apos;re available during business hours to answer your
              questions.
            </p>
            <a
              href="https://wa.me/60122353795"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-8 py-4 bg-white hover:bg-gray-100 text-primary-600 font-semibold rounded-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>Chat on WhatsApp: +6012-2353795</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

/* -------------------------------------------------------------------------- */
/*                               FAQ SECTION                                 */
/* -------------------------------------------------------------------------- */
const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question:
        'What is the minimum investment amount to become a partner with Drixem Group?',
      answer:
        'Our investment tiers start from $0.5M for Export Distribution partnerships, $1M–$5M for Tech Innovation, and $5M–$50M for Joint Venture Manufacturing. Each tier offers different levels of involvement and returns. We recommend scheduling a meeting with our investment team to discuss the best option for your goals.',
    },
    {
      question: 'What is the difference between an Active Partner and a Non-Active Partner?',
      answer:
        'An Active Partner has hands‑on involvement in operations, strategy, and decision‑making with board‑level participation and higher equity stakes. A Non‑Active Partner enjoys passive income with quarterly interim profit sharing, regular performance reports, and zero operational commitment — ideal for investors seeking high‑yield returns without day‑to‑day management responsibilities.',
    },
    {
      question: 'How does Drixem Group ensure the safety and transparency of my investment?',
      answer:
        'Your investment is backed by strategic banking partnerships with Affin Bank, Exim Bank Malaysia, and Citibank Singapore. We maintain full regulatory compliance, government certifications (MPOB, JAKIM Halal, MOH), and provide regular financial reports. Our ultimate ambition is public listing of subsidiaries, ensuring world‑class governance and transparency.',
    },
    {
      question:
        'Can overseas investors participate, and what support is available for foreign nationals?',
      answer:
        'Absolutely. We welcome overseas investors and can arrange the Malaysia My Second Home (MM2H) programme and MIDA (Malaysian Investment Development Authority) approvals to ease your investment entry into Malaysia. We also provide suggestions on international schools for your children. Visit our Investor Relations page for full details.',
    },
    {
      question: 'What returns can I expect, and how often are profits distributed?',
      answer:
        'Expected returns vary by tier: Joint Venture Manufacturing offers 15–25% annual returns, Export Distribution offers 12–18%, and Tech Innovation offers 20–35%. For non‑active partners, we provide quarterly interim profit sharing. All returns are backed by real assets across our six business divisions operating within a Closed‑Loop Ecosystem.',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary-50 rounded-full mb-6">
            <i className="ri-question-answer-line text-primary-600"></i>
            <span className="text-sm text-primary-700 font-medium">
              Frequently Asked Questions
            </span>
          </div>
          <h2 className="text-4xl font-display font-bold text-gray-900 mb-6">
            Investor FAQ
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Answers to the most common questions from potential investors and partners
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-lg transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="text-base font-semibold text-gray-900 pr-4">
                  {faq.question}
                </span>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-xl text-primary-600 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5 text-gray-600 leading-relaxed">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/60122353795"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span>WhatsApp Us</span>
            </a>
            <Link
              to="/investor-relations"
              className="inline-flex items-center space-x-2 px-6 py-3 border-2 border-primary-600 text-primary-600 hover:bg-primary-50 font-semibold rounded-lg transition-all whitespace-nowrap"
            >
              <span>View Investment Details</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* Structured Data – FAQPage */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
};

/* -------------------------------------------------------------------------- */
/*                               CONTACT FORM                                 */
/* -------------------------------------------------------------------------- */
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: '',
  });
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error' | 'captcha'>(
    'idle'
  );

  const handleCaptchaVerified = useCallback((verified: boolean) => {
    setCaptchaVerified(verified);
    if (verified) setSubmitStatus('idle');
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!captchaVerified) {
      setSubmitStatus('captcha');
      return;
    }

    if (!formData.name || !formData.email || !formData.phone || !formData.subject || !formData.message) {
      setSubmitStatus('error');
      return;
    }

    if (formData.message.length > 500) {
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6agvgfmvg9ih2c7ajf0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', company: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form
      id="contact-enquiry-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="bg-white border border-gray-200 rounded-2xl p-8 shadow-lg"
    >
      {/* Name & Email */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-semibold text-gray-900 mb-2">
            Full Name *
          </label>
          <input
            type="text"
            id="contact-name"
            name="name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-semibold text-gray-900 mb-2">
            Email Address *
          </label>
          <input
            type="email"
            id="contact-email"
            name="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
          />
        </div>
      </div>

      {/* Phone & Company */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label htmlFor="contact-phone" className="block text-sm font-semibold text-gray-900 mb-2">
            Phone Number *
          </label>
          <input
            type="tel"
            id="contact-phone"
            name="phone"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
          />
        </div>
        <div>
          <label htmlFor="contact-company" className="block text-sm font-semibold text-gray-900 mb-2">
            Company Name
          </label>
          <input
            type="text"
            id="contact-company"
            name="company"
            value={formData.company}
            onChange={(e) => setFormData({ ...formData, company: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
          />
        </div>
      </div>

      {/* Subject */}
      <div className="mb-6">
        <label htmlFor="contact-subject" className="block text-sm font-semibold text-gray-900 mb-2">
          Subject *
        </label>
        <select
          id="contact-subject"
          name="subject"
          value={formData.subject}
          onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
        >
          <option value="">Select a subject</option>
          <option value="Palm Oil Enquiry">Palm Oil Enquiry</option>
          <option value="Manufacturing Enquiry">Manufacturing Enquiry</option>
          <option value="Property Development Enquiry">Property Development Enquiry</option>
          <option value="B2B Export Trade">B2B Export Trade</option>
          <option value="Advertising & Marketing">Advertising &amp; Marketing</option>
          <option value="AI IT Tech">AI IT Tech</option>
          <option value="Investment Enquiry">Investment Enquiry</option>
          <option value="Partnership Opportunity">Partnership Opportunity</option>
          <option value="General Enquiry">General Enquiry</option>
        </select>
      </div>

      {/* Message */}
      <div className="mb-6">
        <label htmlFor="contact-message" className="block text-sm font-semibold text-gray-900 mb-2">
          Message *
        </label>
        <textarea
          id="contact-message"
          name="message"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          required
          rows={6}
          maxLength={500}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm resize-none"
          placeholder="Tell us how we can help you..."
        />
        <div className="text-xs text-gray-500 mt-1">{formData.message.length}/500 characters</div>
      </div>

      {/* Captcha */}
      <CaptchaField onVerified={handleCaptchaVerified} />

      {/* Feedback messages */}
      {submitStatus === 'success' && (
        <div className="mb-6 p-4 bg-primary-50 border border-primary-200 rounded-lg">
          <p className="text-sm text-primary-700">
            Thank you for contacting us! We&apos;ll get back to you within 24 hours.
          </p>
        </div>
      )}
      {submitStatus === 'error' && (
        <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-700">
            There was an error sending your message. Please try again or WhatsApp us at +6012-2353795.
          </p>
        </div>
      )}
      {submitStatus === 'captcha' && (
        <div className="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
          <p className="text-sm text-amber-700">Please complete the security verification before submitting.</p>
        </div>
      )}

      {/* Submit button */}
      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full px-8 py-4 bg-primary-600 hover:bg-primary-700 disabled:bg-gray-400 text-white font-semibold rounded-lg transition-all whitespace-nowrap"
      >
        {isSubmitting ? 'Sending...' : 'Send Enquiry'}
      </button>
    </form>
  );
};

/* -------------------------------------------------------------------------- */
/*                             APPOINTMENT FORM                               */
/* -------------------------------------------------------------------------- */
const AppointmentForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    preferred_location: '',
    preferred_date: '',
    preferred_time: '',
    partnership_interest: '',
    message: '',
  });
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error' | 'captcha'>(
    'idle'
  );

  const handleCaptchaVerified = useCallback((verified: boolean) => {
    setCaptchaVerified(verified);
    if (verified) setSubmitStatus('idle');
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!captchaVerified) {
      setSubmitStatus('captcha');
      return;
    }

    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.preferred_location ||
      !formData.preferred_date ||
      !formData.preferred_time
    ) {
      setSubmitStatus('error');
      return;
    }

    if (formData.message.length > 500) {
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6agvhnmvg9ih2c7ajfg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          preferred_location: '',
          preferred_date: '',
          preferred_time: '',
          partnership_interest: '',
          message: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Appointment form error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form
      id="investor-appointment-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="bg-white border border-gray-200 rounded-2xl p-8 shadow-lg"
    >
      {/* Name & Email */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label htmlFor="appt-name" className="block text-sm font-semibold text-gray-900 mb-2">
            Full Name *
          </label>
          <input
            type="text"
            id="appt-name"
            name="name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
          />
        </div>
        <div>
          <label htmlFor="appt-email" className="block text-sm font-semibold text-gray-900 mb-2">
            Email Address *
          </label>
          <input
            type="email"
            id="appt-email"
            name="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
          />
        </div>
      </div>

      {/* Phone & Company */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label htmlFor="appt-phone" className="block text-sm font-semibold text-gray-900 mb-2">
            Phone Number *
          </label>
          <input
            type="tel"
            id="appt-phone"
            name="phone"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
          />
        </div>
        <div>
          <label htmlFor="appt-company" className="block text-sm font-semibold text-gray-900 mb-2">
            Company Name
          </label>
          <input
            type="text"
            id="appt-company"
            name="company"
            value={formData.company}
            onChange={(e) => setFormData({ ...formData, company: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
          />
        </div>
      </div>

      {/* Preferred Location */}
      <div className="mb-6">
        <label htmlFor="appt-location" className="block text-sm font-semibold text-gray-900 mb-2">
          Preferred Meeting Location *
        </label>
        <select
          id="appt-location"
          name="preferred_location"
          value={formData.preferred_location}
          onChange={(e) => setFormData({ ...formData, preferred_location: e.target.value })}
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
        >
          <option value="">Select a location</option>
          <option value="Seremban, Negeri Sembilan">Seremban, Negeri Sembilan (HQ)</option>
          <option value="Senai, Johor">Senai, Johor (Office &amp; Factory)</option>
          <option value="Armanie Prestige KLCC">Armanie Prestige KLCC (Office in Construction Phase)</option>
        </select>
      </div>

      {/* Date & Time */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label htmlFor="appt-date" className="block text-sm font-semibold text-gray-900 mb-2">
            Preferred Date *
          </label>
          <input
            type="date"
            id="appt-date"
            name="preferred_date"
            value={formData.preferred_date}
            onChange={(e) => setFormData({ ...formData, preferred_date: e.target.value })}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
          />
        </div>
        <div>
          <label htmlFor="appt-time" className="block text-sm font-semibold text-gray-900 mb-2">
            Preferred Time *
          </label>
          <select
            id="appt-time"
            name="preferred_time"
            value={formData.preferred_time}
            onChange={(e) => setFormData({ ...formData, preferred_time: e.target.value })}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
          >
            <option value="">Select a time</option>
            <option value="9:00 AM">9:00 AM</option>
            <option value="10:00 AM">10:00 AM</option>
            <option value="11:00 AM">11:00 AM</option>
            <option value="12:00 PM">12:00 PM</option>
            <option value="2:00 PM">2:00 PM</option>
            <option value="3:00 PM">3:00 PM</option>
            <option value="4:00 PM">4:00 PM</option>
            <option value="5:00 PM">5:00 PM</option>
          </select>
        </div>
      </div>

      {/* Partnership Interest */}
      <div className="mb-6">
        <label htmlFor="appt-interest" className="block text-sm font-semibold text-gray-900 mb-2">
          Partnership Interest
        </label>
        <select
          id="appt-interest"
          name="partnership_interest"
          value={formData.partnership_interest}
          onChange={(e) => setFormData({ ...formData, partnership_interest: e.target.value })}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm"
        >
          <option value="">Select your interest</option>
          <option value="Active Partner">Active Partner</option>
          <option value="Non-Active Partner">Non-Active Partner</option>
          <option value="Joint Venture">Joint Venture</option>
          <option value="Export Distribution">Export Distribution</option>
          <option value="Tech Innovation">Tech Innovation</option>
          <option value="General Discussion">General Discussion</option>
        </select>
      </div>

      {/* Additional Notes */}
      <div className="mb-6">
        <label htmlFor="appt-message" className="block text-sm font-semibold text-gray-900 mb-2">
          Additional Notes
        </label>
        <textarea
          id="appt-message"
          name="message"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          rows={4}
          maxLength={500}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent text-sm resize-none"
          placeholder="Tell us about your investment interests or any specific topics you'd like to discuss..."
        />
        <div className="text-xs text-gray-500 mt-1">{formData.message.length}/500 characters</div>
      </div>

      {/* Captcha */}
      <CaptchaField onVerified={handleCaptchaVerified} />

      {/* Feedback */}
      {submitStatus === 'success' && (
        <div className="mb-6 p-4 bg-primary-50 border border-primary-200 rounded-lg">
          <div className="flex items-center space-x-2">
            <i className="ri-check-line text-primary-600"></i>
            <p className="text-sm text-primary-700">
              Your appointment request has been submitted! Our team will confirm your meeting within 24
              hours.
            </p>
          </div>
        </div>
      )}
      {submitStatus === 'error' && (
        <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-700">
            Please fill in all required fields. If the issue persists, WhatsApp us at +6012-2353795.
          </p>
        </div>
      )}
      {submitStatus === 'captcha' && (
        <div className="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
          <p className="text-sm text-amber-700">Please complete the security verification before submitting.</p>
        </div>
      )}

      {/* Submit */}
      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full px-8 py-4 bg-primary-600 hover:bg-primary-700 disabled:bg-gray-400 text-white font-semibold rounded-lg transition-all whitespace-nowrap"
      >
        {isSubmitting ? 'Booking...' : 'Book Appointment'}
      </button>
    </form>
  );
};

export default ContactPage;
